import angular from 'angular'
import {react2angular} from "react2angular"

import {NoChannelsBanner} from "./NoChannelsBanner.react"

angular.module("merchant.application.module.settlement.noChannelsBanner", [])
    .component('noChannelsBanner', react2angular(NoChannelsBanner, [], []))
